import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';

export const reportProblemMixin = defineComponent({
  computed: {
    ...mapState('device', ['device']),
    ...mapState('match', ['match'])
  },
  methods: {
    ...mapActions('modal', ['showModal']),
    ...mapActions('match', ['getMatch']),
    ...mapActions('comment', ['indexComments']),
    reportProblem() {
      this.showModal({
        component: 'ReportProblemModal',
        data: { match: this.match }
      });
    }
  },
  async mounted() {
    if (this.device && !this.orderReturn && 'match' in this.device) await this.getMatch(this.device.match.id);
  }
});
